import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionERP from '@/js/services/APIErp';
import { useAppConfigStore } from '@/js/stores/appConfig';

export default class CustomizationsController {
  /// <summary>
  /// Inicializa el módulo de personalizaciones de la APP.
  /// Esta controladora se encarga de obtener la configuración necesaria para el funcionamiento de las personalizaciones.
  /// </summary>
  static async Initialize() {
    Log(this, this.Initialize.name);
    await this.CargarPersonalizacionesFormularios();
  }

  static async CargarPersonalizacionesFormularios() {
    const store = useAppConfigStore();

    try {
      const result = await ConexionERP.callObtenerOperacionesPersonalizadas();
      const { Valor, Mensaje } = result.data;

      if (Valor) {
        const tempPersonalizaciones = JSON.parse(Mensaje);
        store.personalizacionesFormularios = tempPersonalizaciones;
      } else {
        store.personalizacionesFormularios = null;
      }
    } catch (error) {
      LogError(this, this.CargarPersonalizacionesFormularios.name, error);
      store.personalizacionesFormularios = null;
    }
  }
}
